import ActionTypes from '../constants/action-types';

export const setMessageUserListsFilter = (payload) => ({
    type: ActionTypes.SET_MESSAGE_USER_LISTS,
    payload
});

export const resetMessageUserListsFilter = (payload) => ({
    type: ActionTypes.RESET_MESSAGE_USER_LISTS,
    payload
});

export const setShowMessageUserLists = (payload) => ({
    type: ActionTypes.SET_SHOW_MESSAGE_USER_LISTS,
    payload
});